import { GridCell } from '@progress/kendo-react-grid'
import React from 'react'
import { Button } from 'reactstrap'
import { editModal } from '../actions';

export class EditCell extends GridCell {
  public render() {
    return <td>
      <Button className="secondary-button"
              onClick={(() => this.props.dataItem.dispatch(editModal(this.props.dataItem)))}
              id="Edit">
              Edit
      </Button>
    </td>
  }
}



// WEBPACK FOOTER //
// ./src/pages/users/render/edit_cell.tsx